import { render } from "./createApp.vue?vue&type=template&id=689e7741&scoped=true"
import script from "./createApp.vue?vue&type=script&lang=js"
export * from "./createApp.vue?vue&type=script&lang=js"

import "./createApp.vue?vue&type=style&index=0&id=689e7741&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689e7741"]])

export default __exports__